import { Divider, HStack, VStack, Flex, LinkBox, LinkOverlay } from '@chakra-ui/react'
import { CoverImage } from '@!/Store/Common/components'
import { ReadFreeButton } from '@!/Store/FreeFeature/containers/ReadFreeButton'
import { Title } from '@!/Store/FreeFeature/components/Title'

export const TitleList = ({ titles }) => {
  return (
    <VStack spacing={4} py={4} divider={<Divider />}>
      {titles.map((title) => (
        <LinkBox key={title.title_id} w="100%">
          <HStack spacing={4} alignItems="flex-start" w="100%">
            <LinkOverlay href={`/store/books/${title.first_content_id}`}>
              <CoverImage width="90px" src={title.image_url} alt={title.title_name} />
            </LinkOverlay>
            <VStack w="100%">
              <Title title={title} />
              <Flex justifyContent="flex-end" w="100%">
                <ReadFreeButton title={title} />
              </Flex>
            </VStack>
          </HStack>
        </LinkBox>
      ))}
    </VStack>
  )
}
